import * as THREE from 'three';

// Class that creates and updates the main camera
export default class Camera {
	constructor(renderer) {

		const width = renderer.domElement.width;
		const height = renderer.domElement.height;

		this.renderer = renderer;

		// Create and position a Perspective Camera
		this.threeCamera = new THREE.PerspectiveCamera(75, width / height, 0.1, 100);
		this.threeCamera.position.set(0, 0, -4);

		// Initial sizing
		this.updateSize();

		// Listeners
		window.addEventListener('resize', () => this.updateSize(), false);

	}

	updateSize() {
		// Update camera aspect ratio with window aspect ratio
		this.threeCamera.aspect = this.renderer.domElement.width / this.renderer.domElement.height;

		// Always call updateProjectionMatrix on camera change
		this.threeCamera.updateProjectionMatrix();
	}
}
